<form [formGroup]="form" class="flex-row gap-16">
  <mat-form-field class="half-width">
    <mat-label>{{ 'GENERAL.STATUS' | bmsTranslate }}</mat-label>
    <mat-select
      disableOptionCentering
      formControlName="status"
      [placeholder]="'GENERAL.ACTIONS.SELECT_OBJECT' | bmsTranslate: {object: 'GENERAL.STATUS' | bmsTranslate | lowercase}"
      panelClass="bms-theme"
    >
      <mat-option *ngFor="let toolStatus of toolStatuses" [value]="toolStatus"> {{ 'UTILITIES.TOOL.TOOL_STATUS.' + toolStatus | bmsTranslate }} </mat-option>
      <mat-option *ngIf="isStatusInUse" value="IN_USE">{{ 'UTILITIES.TOOL.TOOL_STATUS.IN_USE' | bmsTranslate }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field *ngIf="!isStatusInUse" class="half-width">
    <mat-label>{{ 'UTILITIES.TOOL.STOCK_LOCATION' | bmsTranslate: {count: 1} }}</mat-label>
    <vdw-object-selection
      formControlName="stockLocation"
      [objectName]="'UTILITIES.TOOL.STOCK_LOCATION' | bmsTranslate: {count: 1} | lowercase"
      [canShowMultiSelectPlaceHolder]="false"
      [canShowBMSTheme]="true"
      [withDialogObjectSelection]="true"
      (selectClicked)="selectStockLocation()"
    ></vdw-object-selection>
  </mat-form-field>
</form>
